import { render, staticRenderFns } from "./poupload.vue?vue&type=template&id=fd027f1e"
import script from "./poupload.vue?vue&type=script&lang=js"
export * from "./poupload.vue?vue&type=script&lang=js"
import style0 from "./poupload.vue?vue&type=style&index=0&id=fd027f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports